<template>
  <div id="app" class="app">
    <ScoreBoard class="app__scoreboard"></ScoreBoard>

    <router-view></router-view>
    <button @click="deleteProgress">Delete Progress</button>
  </div>
</template>

<script>
import ScoreBoard from "@/components/ScoreBoard";

export default {
  name: "app",
  components: {
    ScoreBoard
  },
  methods: {
    deleteProgress() {
      if (window.confirm("Are you sure you want to delete your progress?")) {
        this.$store.commit("turnTicksOff");
        window.localStorage.removeItem("vuex");
      }
    }
  }
};
</script>

<style lang="scss">
.app {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem 2rem 1rem;
  background: theme("colors.gray.500");
}
</style>
